// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

export interface ProfileCardTelemetryObjects {
    profileCard: TelemetryObjectBase;
    reportUserMenu: TelemetryObjectBase;
    reportedMessage: TelemetryObjectBase;
    moreButton: TelemetryObjectBase;
}

export const profileCardTelemetryContracts = {
    /** Scenario 0a Impr update */
    profileCard: {
        name: "UserProfile",
        content: {
            headline: "UserProfile",
            type: TelemetryContentType.Profile
        }
    },
    /** Scenario 2 click on report/more/ellipsis button*/
    moreButton: {
        name: "MoreOptions",
        behavior: TelemetryBehaviorType.Report,
        content: {
            headline: "MoreOptions",
            type: TelemetryContentType.Profile
        }
    },
    /** Scenario 3 Impr update of report user*/
    reportUserMenu: {
        name: "ReportUser",
        content: {
            headline: "ReportUser",
            type: TelemetryContentType.Profile
        }
    },
    /** Scenario 4 Impr update of report user reason*/
    reportUserMenuTypes: {
        name: "ReportUserReason",
        content: {
            headline: "ReportUserReason",
            type: TelemetryContentType.Profile
        }
    },
    /** Scenario 5 Impr update of user report complete*/
    reportedMessage: {
        name: "UserReported",
        content: {
            headline: "UserReported",
            type: TelemetryContentType.Profile
        }
    }
};